// ローカル開発環境用設定

const IS_PC = true;
const localAPI = 'http://localhost:9767';
const baseURL = 'http://127.0.0.1:6992';
const loginUrl = 'http://localhost:9767/oauth/token';

// ローカル開発環境（実機アクセス用 - nginx HTTPS）
// const IS_PC = true;
// const localAPI = 'https://192.168.68.113:8443';
// const baseURL = 'https://192.168.68.113:8443';
// const loginUrl = 'https://192.168.68.113:8443/oauth/token';

const CLIENT_ID = '2';
const CLIENT_SECRET = 'oNjIPOLklYQJyRgUwOSpHJQpJJIDMV1P4D8y3RMR';

export default {
  IS_PC,
  localAPI,
  baseURL,
  loginUrl,
  CLIENT_ID,
  CLIENT_SECRET
};
